import React from "react"

const FeeIcon = () => (
  <svg
    height="512"
    viewBox="0 0 64 64"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="m62 31h-8.586l9.293-9.293c.391-.391.391-1.023 0-1.414l-19-19c-.391-.391-1.023-.391-1.414 0l-29.707 29.707h-10.586c-.553 0-1 .448-1 1v26c0 .552.447 1 1 1h14.586l3.707 3.707c.195.195.451.293.707.293s.512-.098.707-.293l3.708-3.707h36.585c.553 0 1-.448 1-1v-26c0-.552-.447-1-1-1zm-19-27.586 17.586 17.586-10 10h-7.635c-.229-2.56-1.333-4.938-3.173-6.778-4.288-4.288-11.267-4.289-15.557 0-1.839 1.84-2.943 4.218-3.173 6.778h-5.635zm-15.773 27.586c-.136-.65.046-1.345.53-1.828l1.829 1.828zm10.788 0c-.11-.145-.228-.285-.358-.414-1.561-1.559-4.097-1.56-5.657 0l-2.829-2.828c.756-.755 2.072-.755 2.828 0l1.414-1.414c-.756-.755-1.76-1.171-2.828-1.171s-2.073.416-2.828 1.171l-.001.001-.707-.707-1.414 1.414.707.707c-.879.879-1.268 2.07-1.143 3.243h-2.141c.223-2.025 1.115-3.902 2.576-5.364 3.51-3.509 9.219-3.508 12.729 0 1.461 1.462 2.354 3.339 2.576 5.364h-2.924zm-17.015 29.586-1.586-1.586h3.172zm40-3.586h-58v-24h58z" />
      <path d="m29 48h-2c0 2.206 1.794 4 4 4v1h2v-1c2.206 0 4-1.794 4-4s-1.794-4-4-4v-4c1.103 0 2 .897 2 2h2c0-2.206-1.794-4-4-4v-1h-2v1c-2.206 0-4 1.794-4 4s1.794 4 4 4v4c-1.103 0-2-.897-2-2zm0-6c0-1.103.897-2 2-2v4c-1.103 0-2-.897-2-2zm4 4c1.103 0 2 .897 2 2s-.897 2-2 2z" />
      <path d="m32 56c6.065 0 11-4.935 11-11s-4.935-11-11-11-11 4.935-11 11 4.935 11 11 11zm0-20c4.963 0 9 4.038 9 9s-4.037 9-9 9-9-4.038-9-9 4.037-9 9-9z" />
      <path d="m59 54v-18c0-.552-.447-1-1-1h-12v2h11v16h-11v2h12c.553 0 1-.448 1-1z" />
      <path d="m6 55h12v-2h-11v-16h11v-2h-12c-.553 0-1 .448-1 1v18c0 .552.447 1 1 1z" />
      <path d="m46 49h2v2h-2z" />
      <path d="m50 49h2v2h-2z" />
      <path d="m46 39h2v2h-2z" />
      <path d="m50 39h2v2h-2z" />
      <path d="m43.272 9.414 11.313 11.314-7.778 7.778 1.414 1.414 8.485-8.485c.391-.391.391-1.023 0-1.414l-12.727-12.728c-.375-.375-1.039-.375-1.414 0l-8.485 8.485 1.414 1.414z" />
      <path
        d="m44.394 24.678h2v2h-2z"
        transform="matrix(.707 -.707 .707 .707 -4.861 39.619)"
      />
      <path
        d="m47.222 21.849h2v2h-2z"
        transform="matrix(.707 -.707 .707 .707 -2.033 40.79)"
      />
      <path
        d="m37.322 17.607h2v2h-2z"
        transform="matrix(.707 -.707 .707 .707 -1.932 32.548)"
      />
      <path
        d="m40.15 14.778h2v2h-2z"
        transform="matrix(.707 -.707 .707 .707 .896 33.719)"
      />
      <path d="m12 39h2v2h-2z" />
      <path d="m16 39h2v2h-2z" />
      <path d="m12 49h2v2h-2z" />
      <path d="m16 49h2v2h-2z" />
    </g>
  </svg>
)

export default FeeIcon
